import errors from './errors/index.js';
import translation from './translation/index.js';
const ko = Object.freeze({
    translation,
    errors,
});
export default ko;
